import { defineMessages } from 'react-intl';

export const clinicStepMessages = defineMessages({
  heading: {
    defaultMessage: 'Name your workspace',
    id: 'fX6g6OuBCu',
    description: 'Heading for the workspace-name step (workspace rename flag on)',
  },
  workspaceNameLabel: {
    defaultMessage: 'Workspace name',
    id: 'e5P9cs0NSG',
    description: 'Label for the workspace-name field (workspace rename flag on)',
  },
  workspaceNamePlaceholder: {
    defaultMessage: 'e.g. Jane’s Workspace',
    id: 'OfPv2UjIcb',
    description: 'Placeholder for the workspace-name input (workspace rename flag on)',
  },
  practiceFieldLabel: {
    defaultMessage: 'Which practice do you work at?',
    id: 'PEE53UrBuI',
    description:
      'Label for the UK CQC practice search field in onboarding-v2 clinic step',
  },
  practiceSearchPlaceholder: {
    defaultMessage: 'Search for your practice',
    id: 'fN38so7T9x',
    description:
      'Helper placeholder shown for UK CQC practice search in onboarding-v2 clinic step',
  },
  ehrListLoadError: {
    defaultMessage: "We couldn't load the EMR/EHR list. Please try again.",
    id: '2u5Zzao6VQ',
    description:
      'Inline error under the EMR/EHR combobox when the country-scoped provider list fails to load',
  },
});
